<h1 mat-dialog-title>{{ data.title }}</h1>
<div mat-dialog-content>
  <p [innerHtml]="data.message"></p>
</div>
<div mat-dialog-actions>
  <ng-container *ngFor="let action of data.actions || []; first as isFirst">
    <button
      *ngIf="!isFirst; else First"
      class="ml-4 w-40"
      mat-flat-button
      [color]="'default'"
      (click)="onAction(action)">
      {{ action }}
    </button>
    <ng-template #First>
      <button class="w-40" mat-flat-button [color]="'primary'" (click)="onAction(action)" cdkFocusInitial>
        {{ action }}
      </button>
    </ng-template>
  </ng-container>
</div>
